<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center">Ustaw alerty - Niech gierki znajdują się same! </span>
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/alerts.jpg" />

  <div class="or-text-lg or-mb-20-px">
    Nie chcesz przegapić żadnej dobrej gierki? Daj Orlikfy działać za Ciebie! Ustaw alerty i pozwól, by to gra znalazła
    Ciebie.
  </div>
  <div class="or-text-lg or-mb-20-px">
    Określ cenę, lokalizację, godzinę, poziom gry, a nawet dzień tygodnia – a my powiadomimy Cię, gdy pojawi się idealna
    gierka!
  </div>
  <div class="or-text-lg or-mb-20-px">Nie trać czasu na szukanie – ustaw alerty i graj, kiedy chcesz!</div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc or-mb-12-px" (click)="handleAction()">
    Ustaw alerty
  </button>

  <button class="button-secondary-style or-h-48-px or-head-md or-w-100-pc" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
